// frontend/src/components/grid/InTransitTooltip.jsx
//
// The In transit cell's hover breakdown by source — see inTransitColumn.js for
// what the parts are and why a zero part is omitted.

import { useTranslation } from 'react-i18next';
import { useFormatters } from '../../hooks/useFormatters';
import { inTransitBreakdown } from '../../utils/inTransitBreakdown';
import './TooltipCard.css';

export function InTransitTooltip(props) {
  const { t } = useTranslation();
  const { formatNumber } = useFormatters();
  const breakdown = inTransitBreakdown(props.data);
  if (!breakdown) return null;

  const part = (labelKey, quantity) => (
    quantity === 0 ? null : (
      <div className="tooltip-card-row tooltip-card-system">
        <span className="tooltip-card-label">{t(labelKey)}</span>
        <span className="tooltip-card-value">{formatNumber(quantity, 0)}</span>
      </div>
    )
  );

  return (
    <div className="tooltip-card">
      {part('inventory.inTransitTooltip.purchaseOrders', breakdown.purchaseOrders)}
      {part('inventory.inTransitTooltip.transfers', breakdown.transfers)}
    </div>
  );
}
